// HACK: This is a pretty rudementary way to get responsiveness

import { ContactsOutlined } from "@material-ui/icons";
import React, { useRef } from "react";
import { useCallback, useEffect, useState } from "react";
import ProcessButton from "./ProcessButton";
import ProcessType from "./ProcessType";

// but works,, we will get back to it.
export default function ProcessButtonMenu(props: any): JSX.Element {
    const [selectedProcessType, setSelectedProcessType] = useState(
        props.bank.filter((p: ProcessType) => {
            return p.name === "None";
        })[0]
    );

    const handle = (p: ProcessType) => {
        setSelectedProcessType(p);
        props.setProcessType(p);
    };

    const renderBtns = useCallback(() => {
        return props.bank.map((p: ProcessType) => {
            // do not show the none option
            if (p.name !== "None") {
                return (
                    <ProcessButton
                        processType={p}
                        selector={handle}
                        selected={selectedProcessType}
                    />
                );
            }
        });
    }, [selectedProcessType]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                backgroundColor: "#CBD2D8",
                borderRadius: "1em",
                padding: "1em",
                border: "10px",
            }}
            className="card"
        >
            {renderBtns()}
        </div>
    );
}
